import { Badge, BadgeVariant } from '../../../components/atoms/badge/badge';
import { StatusSaque, STATUS_SAQUE_LABEL } from '../../../types/saque';

const variantByStatus: Record<StatusSaque, BadgeVariant> = {
  [StatusSaque.PENDING]: 'warning',
  [StatusSaque.ANALYSIS]: 'info',
  [StatusSaque.APPROVED]: 'success',
  [StatusSaque.COMPLETED]: 'primary',
  [StatusSaque.REFUSED]: 'danger',
};

interface Props {
  status: StatusSaque;
  description?: string;
}

export const SaqueStatusBadge = ({ status, description }: Props) => (
  <Badge variant={variantByStatus[status]}>
    {description ?? STATUS_SAQUE_LABEL[status]}
  </Badge>
);
